module.exports = __webpack_public_path__ + "img/alice margatroid_sc1.666cd364.png";